import classNames from 'classnames';

interface ClearButtonProps {
  itemsCount: number;
  label: string;
  onClick: () => void;
  isFullSize?: boolean;
}

export const ClearButton = ({ itemsCount, label, onClick, isFullSize }: ClearButtonProps) => {
  return (
    <button
      type='button'
      onClick={onClick}
      className={classNames('text-subtitle-s transition-colors ml-auto shrink-0', {
        'text-primary': itemsCount > 0,
        'text-tertiary cursor-not-allowed': itemsCount === 0,
        'w-full': isFullSize,
      })}
      disabled={itemsCount === 0}>
      {label}
    </button>
  );
};
